import React from 'react';
import { Box, Container, Stack } from '@mui/material';
import { Outlet } from 'react-router';

import { Header } from '../components';
import Sidebar from '../components/sidebar/Sidebar';

/**
 * Layout with a sidebar and page header.
 * @param {object} props Props accepted by the component.
 * @returns {React.FunctionComponent} React element that contains the component.
 */
function SidebarLayout() {
  return (
    <Stack sx={{ height: '100%', width: '100%' }}>
      <Header />
      <Stack
        direction="row"
        sx={{ height: '100%', width: '100%', overflow: 'hidden' }}
      >
        <Sidebar />
        <Box sx={{ height: '100%', width: '100%', overflow: 'auto' }}>
          <Container
            sx={{
              minHeight: '100%',
              py: 3,
              display: 'flex',
            }}
            maxWidth="xl"
          >
            <Outlet />
          </Container>
        </Box>
      </Stack>
    </Stack>
  );
}

export default SidebarLayout;
